import React, {Component} from 'react';
import PropTypes from 'prop-types';

import KeyboardListener from '~/src/components/listener/keyboard/KeyboardListener';

import {classNames} from '~/src/utilities/helpers/css';

import css from './Notification.module.scss';

class Notification extends Component {
    handleModalClose = () => {
        this.setState({
            slideIn: false,
            slideOut: true
        });
    };

    state = {
        slideIn: true,
        slideOut: false
    };

    componentDidMount() {
        window.setTimeout(() => {
            this.handleModalClose();
            window.setTimeout(() => {
                this.props.onClose();
            }, 1000);
        }, 3000);
    }

    render() {
        const slideIn = this.state.slideIn;
        const slideOut = this.state.slideOut;
        const classes = classNames(css, 'notificationContainer', {slideIn}, {slideOut});

        return (
            <div className={classes} onClick={this.props.handleModalClose}>
                <div className={css.closeButton} onClick={this.handleModalClose} data-testid="NotificationModalClose">
                    {this.props.message || ''}
                </div>
                <KeyboardListener onEsc={this.handleModalClose} />
            </div>
        );
    }
}

if (process.env.NODE_ENV === 'development') {
    Notification.propTypes = {
        onClose: PropTypes.func.isRequired,
        message: PropTypes.string.isRequired
    };
}

export default Notification;
